<!--
  Redirect — sends the visitor to another path as soon as it is rendered (replaces the history
  entry, so "Back" does not bounce). Used for routes that moved, e.g. /tags -> /browse.
-->
<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';

  export let to: string;

  onMount(() => navigate(to, { replace: true }));
</script>
